
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1afi9_c3gkp_94",
  "hidden": "awsui_hidden_1afi9_c3gkp_104",
  "no-items": "awsui_no-items_1afi9_c3gkp_107"
};
  